import url from 'url'

export default
function (ngModule) {
    ngModule.directive('youtubeDocumentCard', [function(){
        return {
            restrict: 'E',
            template: require('./mw-card.html'),
            controllerAs: 'vm',
            controller: 'YoutubeDocumentCardController',
            scope: {
                document: '=?',
                displaySettings: '=',
                documentClick: '&',
                overlaySentiment: '&',
                isNarrowCard: '=',
                showFooter: '=',
                showOpenDocumentIcon: '='
            }
        };
    }])
    .controller('YoutubeDocumentCardController', [
        '$scope',
        'GeoService',
        'translationService',
        'FeatureToggleService',
        YoutubeDocumentCardController]);

    function YoutubeDocumentCardController($scope, GeoService, translationService, FeatureToggleService){

        this.mediaAvailable = false;

        this.onMediaAvailable = function onMediaAvailable() {
            this.mediaAvailable = true;
        }.bind(this);

        var documentClick = function documentClick(url, event) {
            if(url) {
                return $scope.documentClick({
                    event: event,
                    document: $scope.document,
                    url: url
                });
            }
        };

        var update = function update() {

            var documentUrl = $scope.document.redirectUrl || $scope.document.url;
            var videoId = url.parse($scope.document.url, true).query.v;
            var author = ($scope
                && $scope.document
                && $scope.document.authors
                && $scope.document.authors[0])
                || { name: translationService.getLocalizedString('Unknown') };

            this.imagesVisible = $scope.displaySettings.images;
            this.avatarsVisible = $scope.displaySettings.avatar;
            this.isNarrowCard = $scope.isNarrowCard;

            this.showFooter = $scope.showFooter;
            this.showOpenDocumentIcon = $scope.showOpenDocumentIcon;

            this.document = $scope.document;

            var self = this;
            FeatureToggleService.isOn('youtubeDocumentCardVideos')
                .then(function(isEnabled) {
                    if(isEnabled) {
                        self.video = self.imagesVisible && self.document.url.replace('watch?v=', 'embed/').split(':').pop();
                    }
                })
            .catch(function(error) {
                console.error('There was a problem retrieving the state of youtubeDocumentCardVideos toggle: ' + error);
            });

            this.documentId = $scope.document.documentId;
            this.documentUrl = documentUrl;

            this.mediaType = $scope.document.mediaType;
            this.mediaTypeIcon = $scope.document.mediaTypeIcon || $scope.document.mediaType;

            this.avatarTitle = author.name;

            if(videoId) {
              this.avatarImageUrl = videoId
                ? `https://shuhari-iconoclast-production.herokuapp.com/tubicon?videoId=${videoId}`
                : undefined;
            }

            this.avatarLinkUrl = author.url;

            this.sourceName = author.name;
            this.sourceUrl = author.url;

            GeoService.convertCountryCodeToCode3($scope.document.countryCode).then(function(code) {
                this.countryCode = code || null
            }.bind(this));

            this.date = $scope.document.date;

            this.title = $scope.document.title;
            this.text = ($scope.displaySettings.hitSentence && ($scope.document.matchSentence || $scope.document.tagContextMatchSentence))
                ? [$scope.document.matchSentence || $scope.document.tagContextMatchSentence]
                : [];

            this.tags = $scope.displaySettings.displayTags && $scope.document.tags;
            this.keywords = ($scope.displaySettings.keywords && ($scope.document.keywords || $scope.document.tagContextKeywords)) || [];
            this.socialReach = $scope.document.reach;
            this.sentiment = $scope.document.sentiment;
            this.isSentimentModified = $scope.document.isSentimentModified;
            this.originalSentiment = $scope.document.originalSentiment;

            this.onAvatarClick = documentClick.bind(this, author.url);
            this.onSourceIconClick = documentClick.bind(this, documentUrl);
            this.onSourceNameClick = documentClick.bind(this, author.url);
            this.onDocumentOpenClick = documentClick.bind(this, documentUrl);
            this.onTitleClick = documentClick.bind(this, documentUrl);

            this.onOverlaySentimentClick = $scope.overlaySentiment;

        }.bind(this);

        $scope.$watch('displaySettings', update, true);
        $scope.$watch('document', update, true);

        update();
    }

}



// WEBPACK FOOTER //
// ./source/components/document-card/youtube-document-card.js